<div class="country-restriction-dialog">
    <div class="dialog-header">
        <mat-icon class="location-icon">location_off</mat-icon>
        <h2 class="dialog-title">
            {{ 'SUBSCRIPTION_SETTINGS.SERVICE_NOT_AVAILABLE_TITLE' | translate }}
        </h2>
    </div>

    <div class="dialog-content">
        <div class="message">
            <p class="primary-message">
                {{ 'SUBSCRIPTION_SETTINGS.SAUDI_ONLY_MESSAGE' | translate }}
            </p>
            <p class="secondary-message">
                {{ 'SUBSCRIPTION_SETTINGS.QUOTATION_AVAILABLE_MESSAGE' | translate }}
            </p>
        </div>
    </div>

    <div class="dialog-actions">
        <button mat-button class="close-button" (click)="onClose()">
            {{ 'GENERAL.CLOSE' | translate }}
        </button>
        <button mat-raised-button color="primary" class="quote-button" (click)="onRequestQuotation()">
            <mat-icon>request_quote</mat-icon>
            {{ 'SUBSCRIPTION_SETTINGS.REQUEST_QUOTATION' | translate }}
        </button>
    </div>
</div>